"use client";

import SvgReTry from "./SvgReTry";

export function RetryButton() {
  const handleRetry = () => {
    window.location.reload();
  };
  return (
    <button onClick={handleRetry} className="retry-btn" aria-label="Try again">
      <SvgReTry />
      Try again
    </button>
  );
}
